// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3aXBh","obliqueLineWrap":"membershipbadge_obliqueLineWrap__18sPk","obliqueLine":"membershipbadge_obliqueLine__2tINf"};